import { render, staticRenderFns } from "./SoftwareRuntimeTable.vue?vue&type=template&id=8cc9ea76&scoped=true&"
import script from "./SoftwareRuntimeTable.vue?vue&type=script&lang=js&"
export * from "./SoftwareRuntimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc9ea76",
  null
  
)

export default component.exports